import { mapGetters, mapMutations } from "vuex";
import { setBgmState } from "_api/channel";
import { reportData } from "_api/report";
import { PROCESS_ARCH, BGM_WINDOWS_VERSION } from '@/common/constants/rtc';
import { compareVersions } from "_lib/utils/utils";
import EventBus from "_lib/EventBus";

const DEFAULT_BGM_IMG =
  "https://imgheybox.max-c.com/oa/2023/08/31/6e16ffbe8bffea3ebcae859f02bdc780.png";

export default {
  computed: {
    ...mapGetters(["bgm_state"]),
  },
  methods: {
    async trtcSystemAudioChange(bl) {
      console.log(this.bgm_state);
      await this.reportBgmState(bl);
      let _bgm_state = JSON.parse(JSON.stringify(this.bgm_state));
      if (bl) {
        this.SET_BGM_STATE({
          ...this.bgm_state,
          isStart: true,
        });
      } else {
        this.SET_BGM_STATE({});
      }
      await this.$rtc.changeBgmState(bl, this.bgm_state.path);

      if (bl && !_bgm_state.isStart) {
        reportData("bgm:start", {
          channel_id: this.cur_channel_data.channel_id,
          room_id: this.cur_channel_data.room_id,
          audio_share_name: bl ? this.bgm_state.name : "",
        });
      }
    },
    async reportBgmState(bl) {
      let channel_id = this.cur_channel_data.channel_id || this._channel_id;
      let room_id = this.cur_channel_data.room_id || this._room_id;
      if (room_id && channel_id) {
        let res = await setBgmState(
          {
            _notip: 1,
          },
          {
            channel_id: channel_id,
            room_id: room_id,
            audio_share_name: bl ? this.bgm_state.name : "",
            audio_share_icon: bl ? this.bgm_state.image || DEFAULT_BGM_IMG : "",
          }
        );
      }
      this._channel_id = this.cur_channel_data.channel_id;
      this._room_id = this.cur_channel_data.room_id;
    },
    clearBgmState() {
      // 仅清除bgm的状态但是不调用语音的api，在bgm切换为共享屏幕时调用
      this.SET_BGM_STATE({});
      this.reportBgmState(false);
      EventBus.$emit(
        "Add_Room_State_Number",
        this.cur_channel_data.room_id,
        "bgm",
        0
      );
    },
    changeBgmState(data) {
      if (data) {
        this.SET_BGM_STATE({
          ...this.bgm_state,
          bgm_id: data.bgm_id,
          image: data.image || data.icon,
          path: data.path,
          name: data.label,
        });
        if (
          data.arch === PROCESS_ARCH["x64"] &&
          compareVersions(window.windows_version, BGM_WINDOWS_VERSION) < 0
        ) {
          this.$toast.info(
            "当前操作系统版本过低，共享伴奏有概率失败，请升级操作系统后重试"
          );
        }
      } else {
        this.SET_BGM_STATE({});
      }
    },
    ...mapMutations(["SET_BGM_STATE"]),
  },
};
